import React, { useState, useEffect } from 'react';
import { useParams, useNavigate, useLocation } from 'react-router-dom';
import {
  Container,
  Typography,
  Card,
  CardContent,
  CardActions,
  Button,
  Grid,
  Chip,
  IconButton,
  TextField,
  InputAdornment,
  Menu,
  MenuItem,
  ListItemIcon,
  ListItemText,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  FormControl,
  InputLabel,
  Select,
  Avatar,
  Divider,
  Badge,
  Tooltip,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  TablePagination,
  Switch,
  FormControlLabel,
  Slider,
  RadioGroup,
  Radio,
  Checkbox,
  FormGroup,
  Alert,
  Stepper,
  Step,
  StepLabel,
  StepContent,
  Accordion,
  AccordionSummary,
  AccordionDetails,
  List,
  ListItem,
  Box,
  LinearProgress,
  CircularProgress,
  Tabs,
  Tab
} from '@mui/material';
import {
  Search as SearchIcon,
  FilterList as FilterIcon,
  MoreVert as MoreVertIcon,
  Edit as EditIcon,
  Delete as DeleteIcon,
  Visibility as VisibilityIcon,
  Share as ShareIcon,
  Download as DownloadIcon,
  Add as AddIcon,
  Settings as SettingsIcon,
  Person as PersonIcon,
  Security as SecurityIcon,
  Notifications as NotificationsIcon,
  Palette as PaletteIcon,
  Language as LanguageIcon,
  Storage as StorageIcon,
  CloudUpload as CloudUploadIcon,
  CloudDownload as CloudDownloadIcon,
  Sync as SyncIcon,
  Save as SaveIcon,
  Cancel as CancelIcon,
  Check as CheckIcon,
  Warning as WarningIcon,
  Error as ErrorIcon,
  Info as InfoIcon,
  Help as HelpIcon,
  Support as SupportIcon,
  ContactSupport as ContactSupportIcon,
  Email as EmailIcon,
  Phone as PhoneIcon,
  LocationOn as LocationIcon,
  Business as BusinessIcon,
  Work as WorkIcon,
  School as SchoolIcon,
  Public as PublicIcon,
  Lock as LockIcon,
  VpnKey as VpnKeyIcon,
  Fingerprint as FingerprintIcon,
  Shield as ShieldIcon,
  VerifiedUser as VerifiedUserIcon,
  AdminPanelSettings as AdminPanelSettingsIcon,
  ManageAccounts as ManageAccountsIcon,
  AccountCircle as AccountCircleIcon,
  Badge as BadgeIcon,
  CreditCard as CreditCardIcon,
  Payment as PaymentIcon,
  Receipt as ReceiptIcon,
  AttachMoney as MoneyIcon,
  TrendingUp as TrendingUpIcon,
  TrendingDown as TrendingDownIcon,
  Assessment as AssessmentIcon,
  Analytics as AnalyticsIcon,
  Dashboard as DashboardIcon,
  Timeline as TimelineIcon,
  Schedule as ScheduleIcon,
  CalendarToday as CalendarIcon,
  AccessTime as AccessTimeIcon,
  Update as UpdateIcon,
  Refresh as RefreshIcon,
  Restore as RestoreIcon,
  Backup as BackupIcon,
  Archive as ArchiveIcon,
  DeleteForever as DeleteForeverIcon,
  RestoreFromTrash as RestoreFromTrashIcon,
  Folder as FolderIcon,
  FolderOpen as FolderOpenIcon,
  InsertDriveFile as FileIcon,
  Image as ImageIcon,
  VideoLibrary as VideoIcon,
  AudioFile as AudioIcon,
  PictureAsPdf as PdfIcon,
  Description as DocumentIcon,
  TableChart as TableIcon,
  ShowChart as ChartIcon,
  BarChart as BarChartIcon,
  PieChart as PieChartIcon,
  DonutLarge as DonutLargeIcon,
  ScatterPlot as ScatterPlotIcon,
  BubbleChart as BubbleChartIcon,
  MultilineChart as MultilineChartIcon,
  ShowChart as ShowChartIcon,
  TrendingFlat as TrendingFlatIcon,
  TrendingUp as TrendingUpIcon2,
  TrendingDown as TrendingDownIcon2,
  KeyboardArrowDown as KeyboardArrowDownIcon,
  KeyboardArrowUp as KeyboardArrowUpIcon,
  KeyboardArrowLeft as KeyboardArrowLeftIcon,
  KeyboardArrowRight as KeyboardArrowRightIcon,
  ExpandMore as ExpandMoreIcon,
  ExpandLess as ExpandLessIcon,
  Fullscreen as FullscreenIcon,
  FullscreenExit as FullscreenExitIcon,
  ZoomIn as ZoomInIcon,
  ZoomOut as ZoomOutIcon,
  FitScreen as FitScreenIcon,
  CenterFocusStrong as CenterFocusStrongIcon,
  CenterFocusWeak as CenterFocusWeakIcon,
  CropFree as CropFreeIcon,
  CropSquare as CropSquareIcon,
  Crop as CropIcon,
  RotateLeft as RotateLeftIcon,
  RotateRight as RotateRightIcon,
  Flip as FlipIcon,
  Transform as TransformIcon,
  Straighten as StraightenIcon,
  Tune as TuneIcon,
  Adjust as AdjustIcon,
  Brightness4 as Brightness4Icon,
  Brightness7 as Brightness7Icon,
  Contrast as ContrastIcon,
  ColorLens as ColorLensIcon,
  Gradient as GradientIcon,
  Opacity as OpacityIcon,
  BlurOn as BlurOnIcon,
  BlurOff as BlurOffIcon,
  Filter as FilterIcon2,
  Filter1 as Filter1Icon,
  Filter2 as Filter2Icon,
  Filter3 as Filter3Icon,
  Filter4 as Filter4Icon,
  Filter5 as Filter5Icon,
  Filter6 as Filter6Icon,
  Filter7 as Filter7Icon,
  Filter8 as Filter8Icon,
  Filter9 as Filter9Icon,
  Filter9Plus as Filter9PlusIcon,
  FilterBAndW as FilterBAndWIcon,
  FilterCenterFocus as FilterCenterFocusIcon,
  FilterDrama as FilterDramaIcon,
  FilterFrames as FilterFramesIcon,
  FilterHdr as FilterHdrIcon,
  FilterNone as FilterNoneIcon,
  FilterTiltShift as FilterTiltShiftIcon,
  FilterVintage as FilterVintageIcon,
  Grain as GrainIcon,
  GridOn as GridOnIcon,
  GridOff as GridOffIcon,
  ViewModule as ViewModuleIcon,
  ViewList as ViewListIcon,
  ViewComfy as ViewComfyIcon,
  ViewCompact as ViewCompactIcon,
  ViewStream as ViewStreamIcon,
  ViewQuilt as ViewQuiltIcon,
  ViewCarousel as ViewCarouselIcon,
  ViewDay as ViewDayIcon,
  ViewWeek as ViewWeekIcon,
  ViewAgenda as ViewAgendaIcon,
  ViewHeadline as ViewHeadlineIcon,
  ViewSidebar as ViewSidebarIcon,
  ViewColumn as ViewColumnIcon,
  ViewArray as ViewArrayIcon,
  ViewKanban as ViewKanbanIcon,
  ViewTimeline as ViewTimelineIcon,
  Article as ArticleIcon,
  Campaign as CampaignIcon,
  ContactMail as ContactMailIcon,
  Public as PublicIcon2,
  Security as SecurityIcon2,
  Payment as PaymentIcon2,
  Assessment as AssessmentIcon2,
  CreditCard as CreditCardIcon2,
  History as HistoryIcon,
  TrendingUp as TrendingUpIcon3,
  TrendingDown as TrendingDownIcon3,
  Assignment as AssignmentIcon,
  AssignmentTurnedIn as AssignmentTurnedInIcon,
  AssignmentLate as AssignmentLateIcon,
  AssignmentReturn as AssignmentReturnIcon,
  AssignmentReturned as AssignmentReturnedIcon,
  AssignmentInd as AssignmentIndIcon,
  AssignmentLate as AssignmentLateIcon2,
  AssignmentReturn as AssignmentReturnIcon2,
  AssignmentReturned as AssignmentReturnedIcon2,
  AssignmentInd as AssignmentIndIcon2,
  AssignmentLate as AssignmentLateIcon3,
  AssignmentReturn as AssignmentReturnIcon3,
  AssignmentReturned as AssignmentReturnedIcon3,
  AssignmentInd as AssignmentIndIcon3,
  AssignmentLate as AssignmentLateIcon4,
  AssignmentReturn as AssignmentReturnIcon4,
  AssignmentReturned as AssignmentReturnedIcon4,
  AssignmentInd as AssignmentIndIcon4,
  AssignmentLate as AssignmentLateIcon5,
  AssignmentReturn as AssignmentReturnIcon5,
  AssignmentReturned as AssignmentReturnedIcon5,
  AssignmentInd as AssignmentIndIcon5,
  AssignmentLate as AssignmentLateIcon6,
  AssignmentReturn as AssignmentReturnIcon6,
  AssignmentReturned as AssignmentReturnedIcon6,
  AssignmentInd as AssignmentIndIcon6,
  AssignmentLate as AssignmentLateIcon7,
  AssignmentReturn as AssignmentReturnIcon7,
  AssignmentReturned as AssignmentReturnedIcon7,
  AssignmentInd as AssignmentIndIcon7,
  AssignmentLate as AssignmentLateIcon8,
  AssignmentReturn as AssignmentReturnIcon8,
  AssignmentReturned as AssignmentReturnedIcon8,
  AssignmentInd as AssignmentIndIcon8,
  AssignmentLate as AssignmentLateIcon9,
  AssignmentReturn as AssignmentReturnIcon9,
  AssignmentReturned as AssignmentReturnedIcon9,
  AssignmentInd as AssignmentIndIcon9,
  AssignmentLate as AssignmentLateIcon10,
  AssignmentReturn as AssignmentReturnIcon10,
  AssignmentReturned as AssignmentReturnedIcon10,
  AssignmentInd as AssignmentIndIcon10
} from '@mui/icons-material';
import Logo from '../common/Logo';
import { getUserCreditsApi, UserCreditsResponse } from '../../services/paymentApi';

const API_BASE_URL = process.env.REACT_APP_API_URL || 'http://localhost:5000';

interface TabPanelProps {
  children?: React.ReactNode;
  index: number;
  value: number;
}

function TabPanel(props: TabPanelProps) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`settings-tabpanel-${index}`}
      aria-labelledby={`settings-tab-${index}`}
      {...other}
    >
      {value === index && (
        <div style={{ padding: '24px 0' }}>
          {children}
        </div>
      )}
    </div>
  );
}

const SettingsPage: React.FC = () => {
  const { tab } = useParams<{ tab?: string }>();
  const navigate = useNavigate();
  const location = useLocation();

  // Map tab names to indices
  const tabMap: { [key: string]: number } = {
    'profile': 0,
    'notifications': 1,
    'privacy': 2,
    'credits': 3
  };

  // Get tab index from URL or default to 0
  const getTabIndex = () => {
    if (tab && tabMap[tab] !== undefined) {
      return tabMap[tab];
    }
    return 0;
  };

  const [tabValue, setTabValue] = useState(getTabIndex());

  // Update tab value when URL changes
  useEffect(() => {
    const newTabIndex = getTabIndex();
    setTabValue(newTabIndex);
  }, [tab]);

  // Redirect to default tab if no tab in URL and we're at /settings
  useEffect(() => {
    if (location.pathname === '/settings' && !tab) {
      navigate('/settings/profile', { replace: true });
    }
  }, [location.pathname, tab, navigate]);
  const [settings, setSettings] = useState({
    profile: {
      firstName: '',
      lastName: '',
      email: '',
      phone: '',
      company: '',
      position: '',
      industry: 'Technology',
      location: '',
      website: '',
      bio: '',
      avatar: null
    },
    notifications: {
      emailNotifications: true,
      pushNotifications: true,
      smsNotifications: false,
      prUpdates: true,
      campaignUpdates: true,
      paymentUpdates: true,
      reportUpdates: true,
      weeklyDigest: true,
      monthlyReport: true,
      marketingEmails: false
    },
    privacy: {
      loginNotifications: true,
      deviceManagement: true
    },
    appearance: {
      theme: 'light',
      language: 'en',
      timezone: 'America/Los_Angeles',
      dateFormat: 'MM/DD/YYYY',
      timeFormat: '12h',
      fontSize: 'medium',
      colorScheme: 'default',
      sidebarCollapsed: false,
      animations: true
    },
    integrations: {
      googleAnalytics: false,
      facebookPixel: false,
      linkedinInsights: false,
      twitterAnalytics: false,
      slackIntegration: false,
      zapierIntegration: false,
      webhookUrl: '',
      apiKey: ''
    },
    billing: {
      plan: 'professional',
      billingCycle: 'monthly',
      autoRenew: true,
      paymentMethod: 'credit_card',
      invoiceEmail: 'amanda.johnson@techcorp.com',
      taxId: '',
      billingAddress: {
        street: '123 Tech Street',
        city: 'San Francisco',
        state: 'CA',
        zipCode: '94105',
        country: 'United States'
      }
    }
  });

  const [loading, setLoading] = useState(false);
  const [fetchingData, setFetchingData] = useState(true);
  const [saveSuccess, setSaveSuccess] = useState(false);
  const [error, setError] = useState('');
  const [changePasswordDialog, setChangePasswordDialog] = useState(false);
  const [deleteAccountDialog, setDeleteAccountDialog] = useState(false);
  const [exportDataDialog, setExportDataDialog] = useState(false);
  const [passwordData, setPasswordData] = useState({
    currentPassword: '',
    newPassword: '',
    confirmPassword: ''
  });
  const [passwordError, setPasswordError] = useState('');
  const [passwordSuccess, setPasswordSuccess] = useState(false);
  const [changingPassword, setChangingPassword] = useState(false);

  // Credits state for PR packages
  const [creditsData, setCreditsData] = useState<UserCreditsResponse | null>(null);
  const [creditsLoading, setCreditsLoading] = useState(false);
  const [creditsError, setCreditsError] = useState<string | null>(null);

  // Fetch user data on component mount
  useEffect(() => {
    const fetchUserData = async () => {
      setFetchingData(true);
      setError('');
      
      try {
        const token = localStorage.getItem('token');
        if (!token) {
          setError('No authentication token found. Please log in again.');
          setFetchingData(false);
          return;
        }

        // Fetch profile data
        const profileResponse = await fetch(`${API_BASE_URL}/api/auth/profile`, {
          method: 'GET',
          headers: {
            'Authorization': `Bearer ${token}`,
            'Content-Type': 'application/json'
          }
        });

        const profileData = await profileResponse.json();

        if (profileResponse.ok && profileData.success) {
          const user = profileData.user;
          
          // Split fullName into firstName and lastName
          const nameParts = (user.fullName || '').split(' ');
          const firstName = nameParts[0] || '';
          const lastName = nameParts.slice(1).join(' ') || '';

          // Fetch notification preferences
          const notifResponse = await fetch(`${API_BASE_URL}/api/notifications/preferences`, {
            method: 'GET',
            headers: {
              'Authorization': `Bearer ${token}`,
              'Content-Type': 'application/json'
            }
          });

          let notificationPrefs = {
            emailNotifications: true,
            pushNotifications: true,
            smsNotifications: false,
            prUpdates: true,
            campaignUpdates: true,
            paymentUpdates: true,
            reportUpdates: true,
            weeklyDigest: true,
            monthlyReport: true,
            marketingEmails: false
          };

          if (notifResponse.ok) {
            const notifData = await notifResponse.json();
            if (notifData.success && notifData.preferences) {
              notificationPrefs = notifData.preferences;
            }
          }

          // Update settings with real user data
          setSettings(prev => ({
            ...prev,
            profile: {
              ...prev.profile,
              firstName: firstName,
              lastName: lastName,
              email: user.email || '',
              company: user.company || '',
              industry: user.industry || 'Technology',
              phone: user.phone || '',
              position: user.position || '',
              location: user.location || '',
              website: user.website || '',
              bio: user.bio || ''
            },
            notifications: notificationPrefs,
            privacy: {
              ...prev.privacy,
              loginNotifications: user.preferences?.loginNotifications ?? true,
              deviceManagement: true
            },
            billing: {
              ...prev.billing,
              plan: user.plan || 'basic',
              invoiceEmail: user.email || ''
            }
          }));
        } else {
          setError(profileData.message || 'Failed to fetch user data');
        }
      } catch (error: any) {
        console.error('Error fetching user data:', error);
        setError('Failed to load user data. Please refresh the page.');
      } finally {
        setFetchingData(false);
      }
    };

    fetchUserData();
  }, []);

  // Fetch PR credits once for the Credits tab
  useEffect(() => {
    const fetchCredits = async () => {
      try {
        setCreditsLoading(true);
        setCreditsError(null);
        const res = await getUserCreditsApi();
        setCreditsData(res);
      } catch (err: any) {
        setCreditsError(err.message || 'Failed to load PR credits');
      } finally {
        setCreditsLoading(false);
      }
    };
    fetchCredits();
  }, []);

  const handleTabChange = (event: React.SyntheticEvent, newValue: number) => {
    setTabValue(newValue);
    // Navigate to corresponding URL
    const tabNames = ['profile', 'notifications', 'privacy', 'credits'];
    navigate(`/settings/${tabNames[newValue]}`);
  };

  const handleSettingChange = (section: string, key: string, value: any) => {
    const updatedSettings = {
      ...settings,
      [section]: {
        ...settings[section as keyof typeof settings],
        [key]: value
      }
    };
    
    setSettings(updatedSettings);

    // Auto-save notification preferences in real-time
    if (section === 'notifications') {
      saveNotificationPreferences(updatedSettings.notifications);
    }
  };

  // Auto-save notification preferences
  const saveNotificationPreferences = async (notificationSettings: typeof settings.notifications) => {
    try {
      const token = localStorage.getItem('token');
      if (!token) return;

      const response = await fetch(`${API_BASE_URL}/api/notifications/preferences`, {
        method: 'PUT',
        headers: {
          'Authorization': `Bearer ${token}`,
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(notificationSettings)
      });

      const data = await response.json();
      
      if (response.ok && data.success) {
        // Silently save - no need to show success message for auto-save
        console.log('✅ Notification preferences saved automatically');
      } else {
        console.warn('⚠️ Failed to auto-save notification preferences:', data.message);
      }
    } catch (error: any) {
      console.error('❌ Error auto-saving notification preferences:', error);
      // Don't show error to user for auto-save failures
    }
  };

  const handleSaveSettings = async () => {
    setLoading(true);
    setError('');
    
    try {
      const token = localStorage.getItem('token');
      if (!token) {
        setError('No authentication token found. Please log in again.');
        setLoading(false);
        return;
      }

      // Save profile data
      const fullName = `${settings.profile.firstName} ${settings.profile.lastName}`.trim();
      const profileUpdateData = {
        fullName: fullName,
        company: settings.profile.company,
        industry: settings.profile.industry,
        phone: settings.profile.phone,
        position: settings.profile.position,
        location: settings.profile.location,
        website: settings.profile.website,
        bio: settings.profile.bio,
        preferences: {
          notifications: settings.notifications.emailNotifications,
          emailUpdates: settings.notifications.prUpdates || settings.notifications.campaignUpdates || settings.notifications.paymentUpdates,
          smsUpdates: settings.notifications.smsNotifications,
          language: 'en', // Default language
          timezone: 'America/Los_Angeles' // Default timezone
        }
      };

      const profileResponse = await fetch(`${API_BASE_URL}/api/auth/profile`, {
        method: 'PUT',
        headers: {
          'Authorization': `Bearer ${token}`,
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(profileUpdateData)
      });

      const profileData = await profileResponse.json();

      if (!profileResponse.ok || !profileData.success) {
        setError(profileData.message || 'Failed to save profile settings');
        setLoading(false);
        return;
      }

      // Save notification preferences
      const notifResponse = await fetch(`${API_BASE_URL}/api/notifications/preferences`, {
        method: 'PUT',
        headers: {
          'Authorization': `Bearer ${token}`,
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(settings.notifications)
      });

      const notifData = await notifResponse.json();

      if (!notifResponse.ok || !notifData.success) {
        console.warn('Failed to save notification preferences:', notifData.message);
        // Don't fail the whole save if notifications fail
      }

      setSaveSuccess(true);
      setTimeout(() => setSaveSuccess(false), 3000);
      
      // Update localStorage user data
      const userStr = localStorage.getItem('user');
      if (userStr) {
        try {
          const user = JSON.parse(userStr);
          user.firstName = settings.profile.firstName;
          user.lastName = settings.profile.lastName;
          user.company = settings.profile.company;
          user.industry = settings.profile.industry;
          localStorage.setItem('user', JSON.stringify(user));
        } catch (e) {
          console.error('Error updating localStorage:', e);
        }
      }
    } catch (error: any) {
      console.error('Error saving settings:', error);
      setError('Failed to save settings. Please try again.');
    } finally {
      setLoading(false);
    }
  };

  const handleChangePassword = async () => {
    setPasswordError('');
    
    if (!passwordData.currentPassword || !passwordData.newPassword || !passwordData.confirmPassword) {
      setPasswordError('All fields are required');
      return;
    }

    if (passwordData.newPassword.length < 8) {
      setPasswordError('New password must be at least 8 characters long');
      return;
    }

    if (passwordData.newPassword !== passwordData.confirmPassword) {
      setPasswordError('New passwords do not match');
      return;
    }

    setChangingPassword(true);
    
    try {
      const token = localStorage.getItem('token');
      if (!token) {
        setPasswordError('No authentication token found. Please log in again.');
        setChangingPassword(false);
        return;
      }

      const response = await fetch(`${API_BASE_URL}/api/auth/change-password`, {
        method: 'PUT',
        headers: {
          'Authorization': `Bearer ${token}`,
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({
          currentPassword: passwordData.currentPassword,
          newPassword: passwordData.newPassword
        })
      });

      let data;
      try {
        data = await response.json();
      } catch (parseError) {
        // If response is not JSON, try to get text
        const text = await response.text();
        setPasswordError(text || 'Failed to change password. Please try again.');
        return;
      }

      if (response.ok && data.success) {
        setPasswordError('');
        setPasswordSuccess(true);
        // Clear form and close dialog after showing success message
        setTimeout(() => {
          setChangePasswordDialog(false);
          setPasswordData({ currentPassword: '', newPassword: '', confirmPassword: '' });
          setPasswordSuccess(false);
          setSaveSuccess(true);
          setTimeout(() => setSaveSuccess(false), 3000);
        }, 1500);
      } else {
        setPasswordError(data.message || 'Failed to change password');
        setPasswordSuccess(false);
      }
    } catch (error: any) {
      console.error('Error changing password:', error);
      setPasswordError('Failed to change password. Please try again.');
    } finally {
      setChangingPassword(false);
    }
  };

  const handleExportData = () => {
    setExportDataDialog(true);
  };

  const handleDeleteAccount = () => {
    setDeleteAccountDialog(true);
  };

  return (
    <Container maxWidth="xl" style={{ padding: '24px' }}>
      {/* Header */}
      <div style={{ marginBottom: '32px' }}>
        <Typography variant="h4" style={{ fontWeight: 'bold', color: '#0927eb', marginBottom: '8px', display: 'flex', alignItems: 'center', gap: '12px' }}>
          <SettingsIcon style={{ fontSize: '32px' }} />
          Settings
        </Typography>
        <Typography variant="body1" style={{ color: '#666' }}>
          Manage your account preferences, privacy settings, and integrations
        </Typography>
      </div>

      {/* Loading State */}
      {fetchingData && (
        <Box style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', padding: '48px' }}>
          <CircularProgress size={48} />
        </Box>
      )}

      {/* Error Alert */}
      {error && !fetchingData && (
        <Alert severity="error" style={{ marginBottom: '24px' }} onClose={() => setError('')}>
          {error}
        </Alert>
      )}

      {/* Save Success Alert */}
      {saveSuccess && (
        <Alert severity="success" style={{ marginBottom: '24px' }}>
          Settings saved successfully!
        </Alert>
      )}

      {!fetchingData && (
        <>
      {/* Settings content */}

      {/* Settings Tabs */}
      <Paper style={{ borderRadius: '12px', marginBottom: '24px' }}>
        <Tabs
          value={tabValue}
          onChange={handleTabChange}
          variant="scrollable"
          scrollButtons="auto"
          style={{ borderBottom: '1px solid #e0e0e0' }}
        >
          <Tab
            icon={<PersonIcon />}
            label="Profile"
            iconPosition="start"
            style={{ minHeight: '64px' }}
          />
          <Tab
            icon={<NotificationsIcon />}
            label="Notifications"
            iconPosition="start"
            style={{ minHeight: '64px' }}
          />
          <Tab
            icon={<SecurityIcon />}
            label="Privacy & Security"
            iconPosition="start"
            style={{ minHeight: '64px' }}
          />
          <Tab
            icon={<CreditCardIcon2 />}
            label="PR Credits"
            iconPosition="start"
            style={{ minHeight: '64px' }}
          />
        </Tabs>

        {/* Profile Tab */}
        <TabPanel value={tabValue} index={0}>
          <div style={{ padding: '24px' }}>
            <Typography variant="h6" style={{ fontWeight: 'bold', marginBottom: '24px' }}>
              Profile Information
            </Typography>
            <Grid container spacing={3}>
              <Grid item xs={12} md={4}>
                <div style={{ textAlign: 'center' }}>
                  <Avatar
                    style={{
                      width: '120px',
                      height: '120px',
                      margin: '0 auto 16px auto',
                      fontSize: '48px',
                      backgroundColor: '#0927eb'
                    }}
                  >
                    {(settings.profile.firstName?.[0] || '') + (settings.profile.lastName?.[0] || '') || settings.profile.email?.[0]?.toUpperCase() || 'U'}
                  </Avatar>
                  <Button
                    variant="outlined"
                    startIcon={<CloudUploadIcon />}
                    style={{ marginBottom: '16px' }}
                  >
                    Upload Photo
                  </Button>
                  <Typography variant="body2" style={{ color: '#666' }}>
                    JPG, PNG or GIF. Max size 2MB.
                  </Typography>
                </div>
              </Grid>
              <Grid item xs={12} md={8}>
                <Grid container spacing={3}>
                  <Grid item xs={12} sm={6}>
                    <TextField
                      fullWidth
                      label="First Name"
                      value={settings.profile.firstName}
                      onChange={(e) => handleSettingChange('profile', 'firstName', e.target.value)}
                    />
                  </Grid>
                  <Grid item xs={12} sm={6}>
                    <TextField
                      fullWidth
                      label="Last Name"
                      value={settings.profile.lastName}
                      onChange={(e) => handleSettingChange('profile', 'lastName', e.target.value)}
                    />
                  </Grid>
                  <Grid item xs={12} sm={6}>
                    <TextField
                      fullWidth
                      label="Email"
                      type="email"
                      value={settings.profile.email}
                      onChange={(e) => handleSettingChange('profile', 'email', e.target.value)}
                    />
                  </Grid>
                  <Grid item xs={12} sm={6}>
                    <TextField
                      fullWidth
                      label="Phone"
                      value={settings.profile.phone}
                      onChange={(e) => handleSettingChange('profile', 'phone', e.target.value)}
                    />
                  </Grid>
                  <Grid item xs={12} sm={6}>
                    <TextField
                      fullWidth
                      label="Company"
                      value={settings.profile.company}
                      onChange={(e) => handleSettingChange('profile', 'company', e.target.value)}
                    />
                  </Grid>
                  <Grid item xs={12} sm={6}>
                    <TextField
                      fullWidth
                      label="Position"
                      value={settings.profile.position}
                      onChange={(e) => handleSettingChange('profile', 'position', e.target.value)}
                    />
                  </Grid>
                  <Grid item xs={12} sm={6}>
                    <FormControl fullWidth>
                      <InputLabel>Industry</InputLabel>
                      <Select
                        value={settings.profile.industry}
                        onChange={(e) => handleSettingChange('profile', 'industry', e.target.value)}
                        label="Industry"
                      >
                        <MenuItem value="Technology">Technology</MenuItem>
                        <MenuItem value="Healthcare">Healthcare</MenuItem>
                        <MenuItem value="Finance">Finance</MenuItem>
                        <MenuItem value="Education">Education</MenuItem>
                        <MenuItem value="Retail">Retail</MenuItem>
                        <MenuItem value="Manufacturing">Manufacturing</MenuItem>
                        <MenuItem value="Other">Other</MenuItem>
                      </Select>
                    </FormControl>
                  </Grid>
                  <Grid item xs={12} sm={6}>
                    <TextField
                      fullWidth
                      label="Location"
                      value={settings.profile.location}
                      onChange={(e) => handleSettingChange('profile', 'location', e.target.value)}
                    />
                  </Grid>
                  <Grid item xs={12}>
                    <TextField
                      fullWidth
                      label="Website"
                      value={settings.profile.website}
                      onChange={(e) => handleSettingChange('profile', 'website', e.target.value)}
                    />
                  </Grid>
                  <Grid item xs={12}>
                    <TextField
                      fullWidth
                      label="Bio"
                      multiline
                      rows={4}
                      value={settings.profile.bio}
                      onChange={(e) => handleSettingChange('profile', 'bio', e.target.value)}
                    />
                  </Grid>
                </Grid>
              </Grid>
            </Grid>
          </div>
        </TabPanel>

        {/* Notifications Tab */}
        <TabPanel value={tabValue} index={1}>
          <div style={{ padding: '24px' }}>
            <Typography variant="h6" style={{ fontWeight: 'bold', marginBottom: '24px' }}>
              Notification Preferences
            </Typography>
            <Grid container spacing={3}>
              <Grid item xs={12} md={6}>
                <Card style={{ borderRadius: '12px' }}>
                  <CardContent>
                    <Typography variant="h6" style={{ fontWeight: 'bold', marginBottom: '16px' }}>
                      Email Notifications
                    </Typography>
                    <FormGroup>
                      <FormControlLabel
                        control={
                          <Switch
                            checked={settings.notifications.emailNotifications}
                            onChange={(e) => handleSettingChange('notifications', 'emailNotifications', e.target.checked)}
                          />
                        }
                        label="Email Notifications"
                      />
                      <FormControlLabel
                        control={
                          <Switch
                            checked={settings.notifications.prUpdates}
                            onChange={(e) => handleSettingChange('notifications', 'prUpdates', e.target.checked)}
                          />
                        }
                        label="PR Updates"
                      />
                      <FormControlLabel
                        control={
                          <Switch
                            checked={settings.notifications.campaignUpdates}
                            onChange={(e) => handleSettingChange('notifications', 'campaignUpdates', e.target.checked)}
                          />
                        }
                        label="Campaign Updates"
                      />
                      <FormControlLabel
                        control={
                          <Switch
                            checked={settings.notifications.paymentUpdates}
                            onChange={(e) => handleSettingChange('notifications', 'paymentUpdates', e.target.checked)}
                          />
                        }
                        label="Payment Updates"
                      />
                      <FormControlLabel
                        control={
                          <Switch
                            checked={settings.notifications.reportUpdates}
                            onChange={(e) => handleSettingChange('notifications', 'reportUpdates', e.target.checked)}
                          />
                        }
                        label="Report Updates"
                      />
                    </FormGroup>
                  </CardContent>
                </Card>
              </Grid>
              <Grid item xs={12} md={6}>
                <Card style={{ borderRadius: '12px' }}>
                  <CardContent>
                    <Typography variant="h6" style={{ fontWeight: 'bold', marginBottom: '16px' }}>
                      Push Notifications
                    </Typography>
                    <FormGroup>
                      <FormControlLabel
                        control={
                          <Switch
                            checked={settings.notifications.pushNotifications}
                            onChange={(e) => handleSettingChange('notifications', 'pushNotifications', e.target.checked)}
                          />
                        }
                        label="Push Notifications"
                      />
                      <FormControlLabel
                        control={
                          <Switch
                            checked={settings.notifications.smsNotifications}
                            onChange={(e) => handleSettingChange('notifications', 'smsNotifications', e.target.checked)}
                          />
                        }
                        label="SMS Notifications"
                      />
                      <FormControlLabel
                        control={
                          <Switch
                            checked={settings.notifications.weeklyDigest}
                            onChange={(e) => handleSettingChange('notifications', 'weeklyDigest', e.target.checked)}
                          />
                        }
                        label="Weekly Digest"
                      />
                      <FormControlLabel
                        control={
                          <Switch
                            checked={settings.notifications.monthlyReport}
                            onChange={(e) => handleSettingChange('notifications', 'monthlyReport', e.target.checked)}
                          />
                        }
                        label="Monthly Report"
                      />
                      <FormControlLabel
                        control={
                          <Switch
                            checked={settings.notifications.marketingEmails}
                            onChange={(e) => handleSettingChange('notifications', 'marketingEmails', e.target.checked)}
                          />
                        }
                        label="Marketing Emails"
                      />
                    </FormGroup>
                  </CardContent>
                </Card>
              </Grid>
            </Grid>
          </div>
        </TabPanel>

        {/* Privacy & Security Tab */}
        <TabPanel value={tabValue} index={2}>
          <div style={{ padding: '24px' }}>
            <Typography variant="h6" style={{ fontWeight: 'bold', marginBottom: '24px' }}>
              Privacy & Security Settings
            </Typography>
            <Card style={{ borderRadius: '12px', maxWidth: '600px' }}>
              <CardContent>
                <Typography variant="h6" style={{ fontWeight: 'bold', marginBottom: '16px' }}>
                  Security Settings
                </Typography>
                <FormGroup>
                  <FormControlLabel
                    control={
                      <Switch
                        checked={settings.privacy.loginNotifications}
                        onChange={(e) => handleSettingChange('privacy', 'loginNotifications', e.target.checked)}
                      />
                    }
                    label="Login Notifications"
                  />
                  <FormControlLabel
                    control={
                      <Switch
                        checked={settings.privacy.deviceManagement}
                        onChange={(e) => handleSettingChange('privacy', 'deviceManagement', e.target.checked)}
                      />
                    }
                    label="Device Management"
                  />
                </FormGroup>
                <div style={{ marginTop: '32px', paddingTop: '24px', borderTop: '1px solid #e0e0e0' }}>
                  <Button
                    variant="contained"
                    startIcon={<VpnKeyIcon />}
                    onClick={() => setChangePasswordDialog(true)}
                    style={{
                      backgroundColor: '#000000',
                      color: 'white',
                      minWidth: '200px'
                    }}
                  >
                    Change Password
                  </Button>
                </div>
              </CardContent>
            </Card>
            <div style={{ marginTop: '24px' }}>
              <Button
                variant="outlined"
                startIcon={<ShieldIcon />}
                color="error"
                onClick={() => setDeleteAccountDialog(true)}
              >
                Delete Account
              </Button>
            </div>
          </div>
        </TabPanel>

        {/* PR Credits Tab */}
        <TabPanel value={tabValue} index={3}>
          <div style={{ padding: '24px' }}>
            <Typography variant="h6" style={{ fontWeight: 'bold', marginBottom: '24px' }}>
              PR Credits & Packages
            </Typography>

            {creditsLoading && (
              <Box style={{ marginBottom: '16px' }}>
                <LinearProgress />
              </Box>
            )}
            {creditsError && (
              <Alert severity="error" style={{ marginBottom: '16px' }} onClose={() => setCreditsError(null)}>
                {creditsError}
              </Alert>
            )}

            {creditsData ? (
              <>
                <Grid container spacing={3} style={{ marginBottom: '24px' }}>
                  <Grid item xs={12} sm={4}>
                    <Card style={{ borderRadius: '12px' }}>
                      <CardContent>
                        <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
                          <div>
                            <Typography variant="h4" style={{ fontWeight: 'bold', color: '#0927eb' }}>
                              {creditsData.credits?.total ?? 0}
                            </Typography>
                            <Typography variant="body2" style={{ color: '#666' }}>
                              Total Credits Purchased
                            </Typography>
                          </div>
                          <BarChartIcon style={{ fontSize: '40px', color: '#0927eb', opacity: 0.3 }} />
                        </div>
                      </CardContent>
                    </Card>
                  </Grid>
                  <Grid item xs={12} sm={4}>
                    <Card style={{ borderRadius: '12px' }}>
                      <CardContent>
                        <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
                          <div>
                            <Typography variant="h4" style={{ fontWeight: 'bold', color: '#4CAF50' }}>
                              {creditsData.credits?.used ?? 0}
                            </Typography>
                            <Typography variant="body2" style={{ color: '#666' }}>
                              Credits Used
                            </Typography>
                          </div>
                          <HistoryIcon style={{ fontSize: '40px', color: '#4CAF50', opacity: 0.3 }} />
                        </div>
                      </CardContent>
                    </Card>
                  </Grid>
                  <Grid item xs={12} sm={4}>
                    <Card style={{ borderRadius: '12px' }}>
                      <CardContent>
                        <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
                          <div>
                            <Typography variant="h4" style={{ fontWeight: 'bold', color: '#FF9800' }}>
                              {creditsData.credits?.remaining ?? 0}
                            </Typography>
                            <Typography variant="body2" style={{ color: '#666' }}>
                              Remaining Credits
                            </Typography>
                          </div>
                          <CheckIcon style={{ fontSize: '40px', color: '#FF9800', opacity: 0.3 }} />
                        </div>
                      </CardContent>
                    </Card>
                  </Grid>
                </Grid>

                <Paper style={{ padding: '24px', borderRadius: '12px' }}>
                  <Typography variant="subtitle1" style={{ fontWeight: 'bold', marginBottom: '16px' }}>
                    Package History
                  </Typography>
                  {!creditsData.packages || creditsData.packages.length === 0 ? (
                    <Typography variant="body2" style={{ color: '#666' }}>
                      No PR packages found. Purchase a package from the Distribution flow to start using PR credits.
                    </Typography>
                  ) : (
                    <TableContainer>
                      <Table>
                        <TableHead>
                          <TableRow style={{ backgroundColor: '#f5f5f5' }}>
                            <TableCell style={{ fontWeight: 'bold' }}>Package Type</TableCell>
                            <TableCell style={{ fontWeight: 'bold' }}>Total Credits</TableCell>
                            <TableCell style={{ fontWeight: 'bold' }}>Purchased On</TableCell>
                            <TableCell style={{ fontWeight: 'bold' }}>Details</TableCell>
                          </TableRow>
                        </TableHead>
                        <TableBody>
                          {creditsData.packages.map((pkg, idx) => {
                            const renderType = () => {
                              if (pkg.tier === 'custom') return 'Custom Package';
                              if (pkg.tier === '4-5') return 'Tier 4 & 5 Package';
                              return `Tier ${pkg.tier} Package`;
                            };

                            const entries = pkg.tierPRCounts
                              ? Object.entries(pkg.tierPRCounts).filter(([, count]) => count > 0)
                              : [];

                            return (
                              <TableRow key={idx} hover>
                                <TableCell>
                                  <Typography variant="body2" style={{ fontWeight: 600 }}>
                                    {renderType()}
                                  </Typography>
                                  {pkg.tier === 'custom' && (
                                    <Chip
                                      label="Custom"
                                      size="small"
                                      style={{ marginTop: 4, fontSize: '0.7rem', fontWeight: 600, backgroundColor: '#ff9800', color: '#fff' }}
                                    />
                                  )}
                                </TableCell>
                                <TableCell>
                                  <Typography variant="body2" style={{ fontWeight: 600 }}>
                                    {pkg.credits} PR{pkg.credits !== 1 ? 's' : ''}
                                  </Typography>
                                </TableCell>
                                <TableCell>
                                  <Typography variant="body2">
                                    {pkg.purchasedAt ? new Date(pkg.purchasedAt).toLocaleDateString() : 'N/A'}
                                  </Typography>
                                </TableCell>
                                <TableCell>
                                  {entries.length > 0 ? (
                                    <>
                                      <Typography variant="caption" style={{ color: '#666', display: 'block', marginBottom: 4 }}>
                                        Tier-wise credits:
                                      </Typography>
                                      {entries.map(([tier, count]) => (
                                        <Typography key={tier} variant="caption" style={{ color: '#666', display: 'block' }}>
                                          Tier {tier}: {count} PR{count !== 1 ? 's' : ''}
                                        </Typography>
                                      ))}
                                    </>
                                  ) : (
                                    <Typography variant="caption" style={{ color: '#666' }}>
                                      Standard package
                                    </Typography>
                                  )}
                                </TableCell>
                              </TableRow>
                            );
                          })}
                        </TableBody>
                      </Table>
                    </TableContainer>
                  )}
                </Paper>
              </>
            ) : !creditsLoading && !creditsError && (
              <Alert severity="info" style={{ marginBottom: '16px' }}>
                No credits data available. Please try refreshing the page.
              </Alert>
            )}
          </div>
        </TabPanel>
      </Paper>

      {/* Action Buttons */}
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginTop: '24px' }}>
        <div>
          <Button
            variant="outlined"
            startIcon={<CloudDownloadIcon />}
            onClick={handleExportData}
            style={{ marginRight: '16px' }}
          >
            Export Data
          </Button>
          <Button
            variant="outlined"
            startIcon={<DeleteForeverIcon />}
            color="error"
            onClick={handleDeleteAccount}
          >
            Delete Account
          </Button>
        </div>
        <Button
          variant="contained"
          startIcon={loading ? <CircularProgress size={20} /> : <SaveIcon />}
          onClick={handleSaveSettings}
          disabled={loading}
          style={{
            backgroundColor: '#000000',
            color: 'white'
          }}
        >
          {loading ? 'Saving...' : 'Save Settings'}
        </Button>
      </div>

      {/* Change Password Dialog */}
      <Dialog open={changePasswordDialog} onClose={() => {
        setChangePasswordDialog(false);
        setPasswordData({ currentPassword: '', newPassword: '', confirmPassword: '' });
        setPasswordError('');
        setPasswordSuccess(false);
      }} maxWidth="sm" fullWidth>
        <DialogTitle>Change Password</DialogTitle>
        <DialogContent>
          {passwordSuccess && (
            <Alert severity="success" style={{ marginBottom: '16px' }}>
              Password changed successfully!
            </Alert>
          )}
          {passwordError && (
            <Alert severity="error" style={{ marginBottom: '16px' }}>
              {passwordError}
            </Alert>
          )}
          <TextField
            fullWidth
            label="Current Password"
            type="password"
            value={passwordData.currentPassword}
            onChange={(e) => setPasswordData({ ...passwordData, currentPassword: e.target.value })}
            style={{ marginBottom: '16px' }}
          />
          <TextField
            fullWidth
            label="New Password"
            type="password"
            value={passwordData.newPassword}
            onChange={(e) => setPasswordData({ ...passwordData, newPassword: e.target.value })}
            style={{ marginBottom: '16px' }}
            helperText="Must be at least 8 characters long"
          />
          <TextField
            fullWidth
            label="Confirm New Password"
            type="password"
            value={passwordData.confirmPassword}
            onChange={(e) => setPasswordData({ ...passwordData, confirmPassword: e.target.value })}
          />
        </DialogContent>
        <DialogActions>
          <Button onClick={() => {
            setChangePasswordDialog(false);
            setPasswordData({ currentPassword: '', newPassword: '', confirmPassword: '' });
            setPasswordError('');
            setPasswordSuccess(false);
          }}>Cancel</Button>
          <Button 
            variant="contained" 
            style={{ backgroundColor: '#000000', color: 'white' }}
            onClick={handleChangePassword}
            disabled={changingPassword}
          >
            {changingPassword ? 'Changing...' : 'Change Password'}
          </Button>
        </DialogActions>
      </Dialog>

      {/* Delete Account Dialog */}
      <Dialog open={deleteAccountDialog} onClose={() => setDeleteAccountDialog(false)} maxWidth="sm" fullWidth>
        <DialogTitle>Delete Account</DialogTitle>
        <DialogContent>
          <Alert severity="warning" style={{ marginBottom: '16px' }}>
            This action cannot be undone. All your data will be permanently deleted.
          </Alert>
          <Typography variant="body2" style={{ marginBottom: '16px' }}>
            Please type "DELETE" to confirm account deletion:
          </Typography>
          <TextField
            fullWidth
            placeholder="Type DELETE to confirm"
          />
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setDeleteAccountDialog(false)}>Cancel</Button>
          <Button variant="contained" color="error">
            Delete Account
          </Button>
        </DialogActions>
      </Dialog>

      {/* Export Data Dialog */}
      <Dialog open={exportDataDialog} onClose={() => setExportDataDialog(false)} maxWidth="sm" fullWidth>
        <DialogTitle>Export Data</DialogTitle>
        <DialogContent>
          <Typography variant="body2" style={{ marginBottom: '16px' }}>
            Select the data you want to export:
          </Typography>
          <FormGroup>
            <FormControlLabel control={<Checkbox defaultChecked />} label="Profile Information" />
            <FormControlLabel control={<Checkbox defaultChecked />} label="PR Campaigns" />
            <FormControlLabel control={<Checkbox defaultChecked />} label="Analytics Data" />
            <FormControlLabel control={<Checkbox defaultChecked />} label="Payment History" />
            <FormControlLabel control={<Checkbox defaultChecked />} label="Settings" />
          </FormGroup>
          <div style={{ marginTop: '16px' }}>
            <FormControl fullWidth>
              <InputLabel>Export Format</InputLabel>
              <Select defaultValue="json" label="Export Format">
                <MenuItem value="json">JSON</MenuItem>
                <MenuItem value="csv">CSV</MenuItem>
                <MenuItem value="pdf">PDF</MenuItem>
              </Select>
            </FormControl>
          </div>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setExportDataDialog(false)}>Cancel</Button>
          <Button variant="contained" style={{ backgroundColor: '#000000', color: 'white' }}>
            Export Data
          </Button>
        </DialogActions>
      </Dialog>
      </>
      )}
    </Container>
  );
};

export default SettingsPage;